import { getResolveScopeRef, Injectable, Token } from './inject';

/**
 * @deprecated Avoid dependency-injected service locator classes. Use custom React hooks and React context/state instead.
 */
@Injectable()
export class Injector {
	private readonly currentResolution = getResolveScopeRef();

	public resolve<T>(dependencyToken: Token<T>): T {
		return this.currentResolution.resolve(dependencyToken);
	}
}
Injectable.naughtyReflection(Injector, []);
